export default __webpack_public_path__ + "static/media/sensor.da5b68db.jpg";